// Inline Shazam logo (SVG). Used as a visual cue in the EditStationForm
// to indicate that Shazam is the recommended free recognition path.
// Size and color customizable via props.
import React from 'react';

const ShazamLogo = ({ size = 14, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-label="Shazam"
    role="img"
  >
    {/* Blue circle background */}
    <circle cx="12" cy="12" r="11.5" fill="#0066FF" />
    {/* Stylized Shazam "S" wave */}
    <path
      d="M14.1 9.6c.55-.27 1.18-.32 1.78-.12.86.27 1.5 1.01 1.65 1.9.04.21.21.36.42.36.27 0 .47-.24.43-.5-.22-1.27-1.13-2.34-2.39-2.74-.86-.27-1.78-.2-2.59.21l-1.93.97c-.6.3-1.32.35-1.96.13-.93-.31-1.55-1.17-1.55-2.16 0-.24-.2-.44-.44-.44s-.44.2-.44.44c0 1.38.87 2.58 2.16 3.02.93.31 1.92.24 2.78-.19l1.78-.88z"
      fill="#FFFFFF"
      transform="translate(0 -1)"
    />
    <path
      d="M9.9 14.4c-.55.27-1.18.32-1.78.12-.86-.27-1.5-1.01-1.65-1.9-.04-.21-.21-.36-.42-.36-.27 0-.47.24-.43.5.22 1.27 1.13 2.34 2.39 2.74.86.27 1.78.2 2.59-.21l1.93-.97c.6-.3 1.32-.35 1.96-.13.93.31 1.55 1.17 1.55 2.16 0 .24.2.44.44.44s.44-.2.44-.44c0-1.38-.87-2.58-2.16-3.02-.93-.31-1.92-.24-2.78.19l-1.78.88z"
      fill="#FFFFFF"
      transform="translate(0 1)"
    />
  </svg>
);

export default ShazamLogo;
